import { DemoShopstoryProvider } from '../shopstory/provider';
import { Canvas } from '@shopstory/core/react';
import shopstoryConfig from '../shopstory/config';
import React from 'react';
import '../styles/global.css';

function ShopstoryCanvasPage() {
  return (
    <DemoShopstoryProvider>
      <Canvas config={shopstoryConfig} />
    </DemoShopstoryProvider>
  );
}

export default ShopstoryCanvasPage;
